import '@astryxdesign/core/reset.css'
import '@astryxdesign/core/astryx.css'
import './api-bridge'
// Imported here, ahead of index.css, purely for cascade order: at equal specificity the
// later stylesheet in the bundle wins, and driver.css's own .driver-popover rules must lose
// to index.css's token-based repaint of them (see the "Guided editor tour" block at the
// bottom of index.css). Left where the tour module also imports it (editorTour.ts) --
// Vite/ESM dedupes a repeated import of the same resolved module, so this doesn't double the
// output, but it does mean import order, not just import presence, is load-bearing here.
// Without this line, driver.css is pulled in transitively through ./App -> ./lib/editorTour,
// well after index.css below, and driver's rules would win instead.
import 'driver.js/dist/driver.css'
import './index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import App from './App'
import { installAnchorPositionFallback } from './lib/anchorPositionFallback'

// Astryx positions its menus and dropdowns entirely with CSS anchor positioning, which
// Firefox and Safari before 26 do not support -- there, every layer would open in the
// top-left corner of the screen. No-op on browsers that support it.
installAnchorPositionFallback()

if (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN) {
  posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    defaults: '2026-05-30',
    capture_exceptions: true
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
